// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__1HoA_","modal":"Modal_modal__1Y01S","slide-down":"Modal_slide-down__3dKzJ","content":"Modal_content__ekx0r"};